"use strict";

var LoggerInstance = require("js-logger").get("AbstractApi");

var ApiHelper = require("../shared/ApiHelper");
var QueryStringHelper = require("../shared/QueryStringHelper");

var AbstractApi = class {
	constructor() {
		if (this.constructor === AbstractApi) {
			throw new TypeError("Cannot construct AbstractApi instances directly!");
		}
	}

	get(ajaxSettings) {
		ajaxSettings.type = "GET";

		this._processQueryString(ajaxSettings);

		return $.ajax(ajaxSettings).fail((jqXHR, textStatus, errorThrown) => {
			if (textStatus !== "abort") {
				this._logError(ajaxSettings, jqXHR, textStatus, errorThrown);
			}
		});
	}

	post(ajaxSettings) {
		this._processQueryString(ajaxSettings);

		return this._requestWithBody(ajaxSettings, "POST");
	}

	put(ajaxSettings) {
		this._processQueryString(ajaxSettings);

		return this._requestWithBody(ajaxSettings, "PUT");
	}

	delete(ajaxSettings) {
		this._processQueryString(ajaxSettings);

		return this._requestWithBody(ajaxSettings, "DELETE");
	}

	/* Supports the following settings:
		`defaultFileName` - This should include the file extension.
		`queryString`
		`url`
	*/
	download(xmlHttpRequestSettings) {
		xmlHttpRequestSettings = xmlHttpRequestSettings || {};
		var deferred = new $.Deferred();

		this._processQueryString(xmlHttpRequestSettings);

		var request = new XMLHttpRequest();
		request.open("GET", xmlHttpRequestSettings.url);
		request.responseType = "blob";

		request.onload = function (event) {
			try {
				LoggerInstance.debug("Download complete.");

				if (this.status !== 200) {
					deferred.reject(this.status);
					return;
				}

				var contentDisposition = this.getResponseHeader("content-disposition");

				// A Redirect response is also a 200, but does not have the content-disposition header.
				if (this.responseURL !== window.location.href && !contentDisposition) {
					window.location.href = this.responseURL;
					return;
				}

				var fileInfo = ApiHelper.getFileInfo(contentDisposition, xmlHttpRequestSettings.defaultFileName);

				if (xmlHttpRequestSettings.shouldOpenInNewTab) {
					if (xmlHttpRequestSettings.isReport) {
						// Reports Download
						var fileBlob = this.response.slice(0, this.response.size, fileInfo.mimeType);

						var url = URL.createObjectURL(fileBlob);
						// create a new window with a custom title
						var newWindow = window.open("", "_blank");
						newWindow.document.title = fileInfo.fileName;
						// create an iframe element that displays the blob URL
						var iframe = newWindow.document.createElement("iframe");
						iframe.src = url;
						iframe.width = "100%";
						iframe.height = "100%";
						iframe.style.border = "none";
						// append the iframe to the new window's body
						newWindow.document.body.appendChild(iframe);
					} else {
						// Documents Download
						if (fileInfo.mimeType === "application/pdf"
							|| fileInfo.mimeType === "text/pdf") {

							// We open a new tab and navigate to an API url that will display the PDF in the browser.
							var baseUrl = window.location.origin;
							var urlEncodedFileName = encodeURIComponent(fileInfo.fileName);
							var urlEncodedDocumentCode = encodeURIComponent(xmlHttpRequestSettings.documentCode);
							var url = `${baseUrl}/api/documents/download/${urlEncodedFileName}?documentCode=${urlEncodedDocumentCode}&viewInBrowser=true`;

							var downloadLink = document.createElement('a');
							downloadLink.style.display = 'none';
							downloadLink.href = url;
							downloadLink.target = "_blank";
							document.body.appendChild(downloadLink);
							downloadLink.click();
							document.body.removeChild(downloadLink);
							URL.revokeObjectURL(url);
						} else {
							var downloadLink = document.createElement('a');
							downloadLink.style.display = 'none';
							downloadLink.href = url;
							downloadLink.download = fileInfo.fileName;
							document.body.appendChild(downloadLink);
							downloadLink.click();
							document.body.removeChild(downloadLink);
							URL.revokeObjectURL(url);
						}
					}
				} else {
					// Create an anchor element with an object url for the href.
					var a = document.createElement("a");
					a.style.display = 'none';
					a.href = window.URL.createObjectURL(this.response);
					a.download = fileInfo.fileName;

					// Download the file with default browser behavior
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}

				deferred.resolve();
			}
			catch (error) {
				deferred.reject();
			}
		}

		request.onabort = function (event) {
			LoggerInstance.debug("Download aborted.");

			// We don't consider an aborted download an error.
			deferred.resolve();
		};

		request.onerror = function (event) {
			LoggerInstance.error(`Download failed: ${settings.url}.`, this.response, this.status);
			deferred.reject(this.status);
		};

		request.send();

		return deferred;
	}

	_removeCaptchaSpinner(e) {
		var challenge = $("iframe[title*='recaptcha'][title*='challenge']");
		// This boolean is based on how Google is currently showing/hiding their reCaptcha challenge
		// If things start breaking, it might be because they have changed how they do this
		var isChallengeVisible = !(challenge.css("visibility") == "hidden");

		if (challenge.length > 0 && isChallengeVisible && !challenge.is(e.target) && challenge.has(e.target).length === 0) {
			$("#overlayWithSpinner").remove();
		}
	}

	_processQueryString(ajaxSettings) {
		var queryString;
		if (ajaxSettings.queryString) {
			if (typeof ajaxSettings.queryString === "string") {
				queryString = ajaxSettings.queryString;
			} else {
				queryString = QueryStringHelper.createQueryString(ajaxSettings.queryString);
			}

			if (queryString) {
				ajaxSettings.url = `${ajaxSettings.url}?${queryString}`;
			}

			delete ajaxSettings.queryString;
		}
	}

	_requestWithBody(ajaxSettings, type) {
		if (ajaxSettings.reCAPTCHA && window.reCAPTCHA) {
			ajaxSettings.headers = ajaxSettings.headers || {};

			// Do not challenge again if reCAPTCHA has already validated (this is the case with Apple and Google Pay).
			if (ajaxSettings.data && ajaxSettings.data.reCAPTCHAResponseToken) {
				ajaxSettings.headers.reCAPTCHAResponseToken = ajaxSettings.data.reCAPTCHAResponseToken;
				delete ajaxSettings.data.reCAPTCHAResponseToken;
				return this._performRequestWithBody(ajaxSettings, type);
			}

			var deferred = new $.Deferred();
			var that = this;
			document.addEventListener("mouseup", that._removeCaptchaSpinner);

			$("#recaptcha").one("Success", (event, token) => {
				ajaxSettings.headers.reCAPTCHAResponseToken = token;
				this._performRequestWithBody(ajaxSettings, type)
					.done(deferred.resolve)
					.fail(deferred.reject);
			});
			if (!window.callingReCAPTCHA) {
				grecaptcha.execute();
			}
			return deferred;

		}
		return this._performRequestWithBody(ajaxSettings, type);
	}

	_performRequestWithBody(ajaxSettings, type) {
		ajaxSettings.type = type;
		ajaxSettings.contentType = ajaxSettings.contentType || "application/json";
		if (ajaxSettings.contentType === "application/json" && typeof ajaxSettings.data !== "string") {
			ApiHelper.convertEmptyValuesToNull(ajaxSettings.data);
			ajaxSettings.data = JSON.stringify(ajaxSettings.data);
		}

		return $.ajax(ajaxSettings).fail((jqXHR, textStatus, errorThrown) => this._logError(ajaxSettings, jqXHR, textStatus, errorThrown));
	}

	_logError(settings, jqXHR, textStatus, errorThrown) {
		LoggerInstance.error(`Failed to ${settings.type} ${settings.url}.`, jqXHR, textStatus, errorThrown);
	}
};

module.exports = AbstractApi;